if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.slides = [];
        this.currentIndex = 0;

        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        this.counterCurrent = this.querySelector('.product-media-modal__counter-current');
        this.counterTotal = this.querySelector('.product-media-modal__counter-total');
        this.zoomButton = this.querySelector('.product-media-modal__zoom');

        if (this.prevButton) {
          this.prevButton.addEventListener('click', (e) => {
            e.stopPropagation();
            this.previous();
          });
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', (e) => {
            e.stopPropagation();
            this.next();
          });
        }
        if (this.zoomButton) {
          this.zoomButton.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleZoom();
          });
        }

        // Prevent parent ModalDialog's pointerup listener from closing modal on control clicks
        this.addEventListener('pointerup', (e) => {
          if (e.target.closest('.product-media-modal__content, .product-media-modal__nav, .product-media-modal__zoom, .product-media-modal__counter, .product-media-modal__toggle')) {
            e.stopPropagation();
          }
        }, true);

        // Backdrop click to close
        const dialog = this.querySelector('.product-media-modal__dialog');
        if (dialog) {
          dialog.addEventListener('click', (e) => {
            if (e.target === dialog || e.target === this.querySelector('.product-media-modal__content') || e.target.classList.contains('product-media-modal__slide')) {
              this.hide();
            }
          });
        }

        this.initGestures();
      }

      connectedCallback() {
        super.connectedCallback();
        this.slides = [...this.querySelectorAll('.product-media-modal__slide')];
        this.total = this.slides.length;
        if (this.counterTotal) this.counterTotal.textContent = this.total;
      }

      initGestures() {
        const dialog = this.querySelector('.product-media-modal__dialog') || this;
        let startX = 0;
        let startY = 0;
        let isTracking = false;

        const onTouchStart = (e) => {
          const activeSlide = this.slides[this.currentIndex];
          if (activeSlide && activeSlide.classList.contains('is-zoomed')) return;
          if (e.touches && e.touches.length !== 1) return;
          const touch = e.touches ? e.touches[0] : e;
          startX = touch.clientX;
          startY = touch.clientY;
          isTracking = true;
        };

        const onTouchMove = (e) => {
          if (!isTracking) return;
          const activeSlide = this.slides[this.currentIndex];
          if (activeSlide && activeSlide.classList.contains('is-zoomed')) {
            isTracking = false;
            return;
          }
          const touch = e.touches ? e.touches[0] : e;
          const currentX = touch.clientX;
          const currentY = touch.clientY;
          const diffX = currentX - startX;
          const diffY = currentY - startY;

          if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 10) {
            if (e.cancelable) e.preventDefault();
          }
        };

        const onTouchEnd = (e) => {
          if (!isTracking) return;
          isTracking = false;
          const activeSlide = this.slides[this.currentIndex];
          if (activeSlide && activeSlide.classList.contains('is-zoomed')) return;

          const touch = e.changedTouches ? e.changedTouches[0] : e;
          if (!touch) return;
          const endX = touch.clientX;
          const endY = touch.clientY;
          const diffX = endX - startX;
          const diffY = endY - startY;
          const threshold = 35;

          if (Math.abs(diffX) > threshold && Math.abs(diffX) > Math.abs(diffY)) {
            if (diffX < 0) {
              this.next();
            } else {
              this.previous();
            }
          }
        };

        dialog.addEventListener('touchstart', onTouchStart, { passive: true });
        dialog.addEventListener('touchmove', onTouchMove, { passive: false });
        dialog.addEventListener('touchend', onTouchEnd, { passive: true });
      }

      hide() {
        super.hide();
        this.resetZoom();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia(opener);
      }

      showActiveMedia(opener) {
        this.slides = [...this.querySelectorAll('.product-media-modal__slide')];
        this.total = this.slides.length;
        if (this.counterTotal) this.counterTotal.textContent = this.total;

        const targetId = opener ? opener.getAttribute('data-media-id') : null;
        let index = -1;
        if (targetId) {
          index = this.slides.findIndex((slide) => slide.dataset.mediaId === targetId);
        }
        if (index < 0) index = this.currentIndex || 0;
        this.goTo(index);

        const activeSlide = this.slides[this.currentIndex];
        const activeMediaTemplate = activeSlide ? activeSlide.querySelector('template') : null;
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeSlide &&
          activeSlide.querySelector('deferred-media') &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeSlide.querySelector('deferred-media').loadContent();
        }
      }

      goTo(index) {
        this.resetZoom();
        if (!this.slides.length) return;
        this.currentIndex = (index + this.slides.length) % this.slides.length;
        const isMobile = window.innerWidth < 768;

        this.slides.forEach((slide, i) => {
          const active = i === this.currentIndex;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('hidden', !active);
          slide.style.display = active ? 'flex' : 'none';

          if (active) {
            const img = slide.querySelector('img');
            if (img) {
              const maxH = isMobile ? window.innerHeight - 90 : window.innerHeight - 100;
              const maxW = isMobile ? window.innerWidth - 32 : window.innerWidth - 120;
              img.style.maxHeight = maxH + 'px';
              img.style.maxWidth = maxW + 'px';
              img.style.width = 'auto';
              img.style.height = 'auto';
              img.style.objectFit = 'contain';
            }
            const media = slide.querySelector('.media');
            if (media) {
              media.style.maxHeight = 'calc(100vh - 5rem)';
              media.style.display = 'flex';
              media.style.alignItems = 'center';
              media.style.justifyContent = 'center';
              media.style.overflow = 'hidden';
            }
          }
        });

        if (this.counterCurrent) this.counterCurrent.textContent = this.currentIndex + 1;
        this.updateNavState();
      }

      next() {
        this.goTo(this.currentIndex + 1);
      }

      previous() {
        this.goTo(this.currentIndex - 1);
      }

      updateNavState() {
        if (!this.prevButton || !this.nextButton) return;
        const single = this.slides.length <= 1;
        this.prevButton.disabled = single;
        this.nextButton.disabled = single;
      }

      toggleZoom() {
        const activeSlide = this.slides[this.currentIndex];
        if (!activeSlide) return;
        const currentlyZoomed = activeSlide.classList.contains('is-zoomed');
        activeSlide.classList.toggle('is-zoomed', !currentlyZoomed);
        const media = activeSlide.querySelector('.media');
        const img = activeSlide.querySelector('img');
        if (!currentlyZoomed) {
          if (img) {
            img.style.transform = 'scale(1.6)';
            img.style.cursor = 'zoom-out';
          }
          if (media) media.style.transform = 'scale(1.6)';
        } else {
          if (img) {
            img.style.transform = '';
            img.style.cursor = '';
          }
          if (media) media.style.transform = '';
        }
        if (this.zoomButton) this.zoomButton.setAttribute('aria-pressed', String(!currentlyZoomed));
      }

      resetZoom() {
        this.slides.forEach((slide) => {
          slide.classList.remove('is-zoomed');
          const media = slide.querySelector('.media');
          const img = slide.querySelector('img');
          if (img) {
            img.style.transform = '';
            img.style.cursor = '';
          }
          if (media) media.style.transform = '';
        });
        if (this.zoomButton) this.zoomButton.setAttribute('aria-pressed', 'false');
      }
    }
  );
}
